module.exports = __webpack_public_path__ + "img/cashier02.b7c9b821.png";